import { Link } from "react-router-dom";
import { Instagram, Linkedin, ArrowUpRight } from "lucide-react";
import { COMPANY } from "@/data/content";
import LennonLogo from "@/components/LennonLogo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-ink text-paper mt-32">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <Link to="/contact" data-testid="footer-cta-lets-talk" className="block group">
          <span
            className="display block text-paper group-hover:text-warm-400 transition-colors duration-700"
            style={{ fontSize: "clamp(56px, 11vw, 200px)", letterSpacing: "-0.04em" }}
          >
            Let&rsquo;s talk.
          </span>
          <span className="mt-8 inline-flex items-center gap-3 eyebrow text-warm-400 group-hover:text-paper transition-colors">
            Start the conversation <ArrowUpRight size={14} />
          </span>
        </Link>
      </div>

      <div className="mx-auto max-w-[1500px] px-6 md:px-10 lg:px-14 pb-12">
        <div className="pt-12 border-t border-paper/15 mb-12 flex flex-wrap items-center justify-between gap-6">
          <Link to="/" className="text-paper hover:opacity-70 transition-opacity">
            <LennonLogo variant="horizontal" size="lg" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-paper">
          <div>
            <div className="eyebrow text-warm-400 mb-3">Offices</div>
            <ul className="space-y-1 text-base">
              {COMPANY.studios.map((s) => (
                <li key={s.city}>{s.city}<span className="text-warm-400"> · {s.region.split(",")[0]}</span></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="eyebrow text-warm-400 mb-3">Direct</div>
            <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="text-base hover:text-warm-400 transition-colors">
              {COMPANY.email}
            </a>
          </div>
          <div>
            <div className="eyebrow text-warm-400 mb-3">Follow</div>
            <div className="flex items-center gap-4">
              <a href={COMPANY.socials.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="text-paper hover:text-warm-400 transition-colors"><Instagram size={20} /></a>
              <a href={COMPANY.socials.linkedin} target="_blank" rel="noreferrer" data-testid="footer-linkedin" className="text-paper hover:text-warm-400 transition-colors"><Linkedin size={20} /></a>
            </div>
          </div>
          <div>
            <div className="eyebrow text-warm-400 mb-3">Index</div>
            <ul className="space-y-1 text-sm">
              <li><Link to="/creators" className="hover:text-warm-400">Creators</Link></li>
              <li><Link to="/work" className="hover:text-warm-400">Work</Link></li>
              <li><Link to="/about" className="hover:text-warm-400">About</Link></li>
              <li><Link to="/press" className="hover:text-warm-400">Press</Link></li>
              <li><Link to="/contact" className="hover:text-warm-400">Contact</Link></li>
            </ul>
            <div className="mt-6 pt-6 border-t border-paper/15">
              <div className="eyebrow text-warm-400 mb-2">For companies</div>
              <a href={COMPANY.companiesUrl} target="_blank" rel="noreferrer" data-testid="footer-lennon-global" className="inline-flex items-center gap-1.5 text-sm text-paper hover:text-warm-400 transition-colors">
                Lennon Global <ArrowUpRight size={12} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 eyebrow text-warm-500">
          <div>© {new Date().getFullYear()} Lennon. All rights reserved.</div>
          <div>Est. {COMPANY.established} — {COMPANY.location}</div>
        </div>
      </div>
    </footer>
  );
}
